import { SMOOTH_SCROLL_CONFIGURATION } from 'data/global';
import { REPLY_SUGGESTION_ACTION } from 'models/Message';
import { richTextJsonToPlainText } from 'components/RichTextEditorField/utils';
import { getArrayLength } from 'utils';

export type FocusTrigger = string | number | boolean;

export const MESSAGE_FORM_ID = 'message-form-input';

// Native focus() leaves Slate without a DOM selection, so no caret shows
const placeCaretAtEnd = (element: HTMLElement) => {
  const leaves = element.querySelectorAll(
    '[data-slate-string], [data-slate-zero-width]',
  );
  const textNode = leaves[leaves.length - 1]?.firstChild;

  if (textNode?.nodeType !== Node.TEXT_NODE) return;

  const isZeroWidth = !!textNode.parentElement.dataset.slateZeroWidth;

  const range = document.createRange();
  range.setStart(textNode, isZeroWidth ? 0 : textNode.textContent.length);
  range.collapse(true);

  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
};

export const focusMessageFormInput = (form: HTMLFormElement) => {
  const element = form?.querySelector<HTMLElement>(`#${MESSAGE_FORM_ID}`);

  if (!element) return;

  element.scrollIntoView({
    ...SMOOTH_SCROLL_CONFIGURATION,
    block: 'nearest',
  });

  setTimeout(() => {
    if (!element.isConnected) return;

    element.focus();
    placeCaretAtEnd(element);
  }, 500);
};

const REPLY_SUGGESTION_MAX_WORDS = 8;

export const getShortenedReplySuggestion = (suggestion: string) => {
  const words = suggestion.trim().split(/\s+/);

  if (getArrayLength(words) <= REPLY_SUGGESTION_MAX_WORDS) return suggestion;

  return `${words.slice(0, REPLY_SUGGESTION_MAX_WORDS).join(' ')}...`;
};

export const getSuggestionAction = (
  message: string,
  selectedSuggestion?: string,
) => {
  if (!selectedSuggestion) return REPLY_SUGGESTION_ACTION.NONE;

  return richTextJsonToPlainText(message) === selectedSuggestion.trim()
    ? REPLY_SUGGESTION_ACTION.UNCHANGED
    : REPLY_SUGGESTION_ACTION.EDITED;
};

export const getIsReplySuggestionShortened = (suggestion: string) =>
  getShortenedReplySuggestion(suggestion) !== suggestion;
